import { createDiscussion } from '../actions/discussions';
import { updateChatsUserState } from '../actions/user-state';

import { trackEvent } from '../services/events-tracker-service';
import { getVisibleChats } from '../services/store-service';

export const startConversation = userId => {
    if (!userId) {
        return;
    }

    return createDiscussion({
        invitees: [userId]
    }).then(({ id: conversationId }) => {
        trackEvent('CHAT.CREATE_PERSONAL');

        updateChatsUserState({
            visible: [...new Set([...getVisibleChats(), conversationId])].filter(Boolean)
        });

        return conversationId;
    });
}
